import React from "react";
import { connect } from "react-redux";

import "./index.css";
import * as actions from "../../../../store/actions";

import Notes from "./Notes";
import LockNotes from "./LockNotes";
import AddNote from "./AddNote";

const MainNotes = ({ viewMode, setViewMode }) => {
  const CurrentComponent = () => {
    switch (viewMode) {
      case 1:
        return <Notes changeView={setViewMode} />;
      case 2: {
        return <LockNotes changeView={setViewMode} />;
      }
      case 3:
        return <AddNote changeView={setViewMode} />;

      default:
        return <Notes changeView={setViewMode} />;
    }
  };

  return (
    <>
      <CurrentComponent />
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation, api }) => ({
  viewMode: dashboard?.templates?.viewMode,
});

const mapDispatchToProps = dispatch => ({
  setViewMode: id => dispatch(actions.setViewMode(id)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(MainNotes);
